/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  StandardError,
  SupporterClaimKey
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Show the supporter claim key
 */
export const mySupporterClaimKey = (

 signal?: AbortSignal
) => {


      return axiosClient<SupporterClaimKey>(
      {url: `/me/supporter/claim-key`, method: 'GET', signal
    },
      );
    }




export const getMySupporterClaimKeyQueryKey = () => {
    return [
    'me','supporter','claim-key'
    ] as const;
    }


export const getMySupporterClaimKeyQueryOptions = <TData = Awaited<ReturnType<typeof mySupporterClaimKey>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMySupporterClaimKeyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mySupporterClaimKey>>> = ({ signal }) => mySupporterClaimKey(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>
}

export type MySupporterClaimKeyQueryResult = NonNullable<Awaited<ReturnType<typeof mySupporterClaimKey>>>
export type MySupporterClaimKeyQueryError = ErrorType<StandardError>


/**
 * @summary Show the supporter claim key
 */

export function useMySupporterClaimKey<TData = Awaited<ReturnType<typeof mySupporterClaimKey>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMySupporterClaimKeyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






